import { HTMLElementNotFoundError } from "./errors/HtmlElementNotFoundError";


/**
 * @class Appender
 * @param {HTMLElement} axTyreMotionResultSearch - The result search container
 * @param {HTMLElement} axTyreMotionCurrentResultSearch - The current result search container
 * @param {HTMLElement} axTyreMotionTyreChoice - The tyre choice container
 */
export class Appender {
    constructor(axTyreMotionResultSearch, axTyreMotionCurrentResultSearch, axTyreMotionTyreChoice) {
        if(!Boolean(axTyreMotionResultSearch)) throw new HTMLElementNotFoundError('No result search container found');
        this.axTyreMotionResultSearch = axTyreMotionResultSearch;
        if(!Boolean(axTyreMotionCurrentResultSearch)) throw new HTMLElementNotFoundError('No CURRENT result search container found');
        this.axTyreMotionCurrentResultSearch = axTyreMotionCurrentResultSearch;
        if(!Boolean(axTyreMotionTyreChoice)) throw new HTMLElementNotFoundError('No tyre choice container found');
        this.axTyreMotionTyreChoice = axTyreMotionTyreChoice;
    }

    appendResultModel = (result) => {
        if(result.tyre_dimensions.current && this.axTyreMotionCurrentResultSearch.childElementCount === 0) {
            const templateResultCurrent = document.getElementById('axtyremotion-current-result-model');
            const cloneCurrent = templateResultCurrent.content.cloneNode(true);
            const elementCurrent = cloneCurrent.querySelector('.size span');
            if(!Boolean(elementCurrent)) throw new HTMLElementNotFoundError('No size element found in result model template');
            elementCurrent.textContent = this.formatTyresizeString(result.tyre_dimensions?.current);
            cloneCurrent.querySelector('button')?.setAttribute('data-result', btoa(JSON.stringify(result)))
            this.axTyreMotionCurrentResultSearch.appendChild(cloneCurrent);
        }

        if(result.tyre_dimensions.oe_front && result.tyre_dimensions.oe_rear) {
            const templateResult = document.getElementById('axtyremotion-result-model');
            const clone = templateResult.content.cloneNode(true);
            clone.querySelector('.model').textContent = result.brand + ' ' + result.model;
            const beforeElement = clone.querySelector('.before span');
            if(!Boolean(beforeElement)) throw new HTMLElementNotFoundError('No before element found in result model template');
            beforeElement.textContent = this.formatTyresizeString(result.tyre_dimensions?.oe_front);
            const afterElement = clone.querySelector('.after span');
            if(!Boolean(afterElement)) throw new HTMLElementNotFoundError('No after element found in result model template');
            afterElement.textContent = this.formatTyresizeString(result.tyre_dimensions?.oe_rear);
            clone.querySelector('button')?.setAttribute('data-result', btoa(JSON.stringify(result)))
            this.axTyreMotionResultSearch.appendChild(clone);
        }

    }

    appendCurrentResultModel = (result) => {
        this.axTyreMotionCurrentResultSearch.appendChild();
    }

    appendChoicePositionButtons(result, position) {
        if(position !== 'front' && position !== 'rear') throw new Error('Position must be "front" or "rear"');
        const templateButton = document.getElementById('axtyremotion-result-position-' + position);
        if(!Boolean(templateButton)) throw new HTMLElementNotFoundError('No template result found for position ' + position);
        const clone = templateButton.content.cloneNode(true);
        const infoElement = clone.querySelector('.info span');
        if(!Boolean(infoElement)) throw new HTMLElementNotFoundError('No before element found in result model template');
        if(position === 'rear') {
            infoElement.textContent = this.formatTyresizeString(result.tyre_dimensions?.oe_rear);
            clone.querySelector('button')?.setAttribute('data-result', btoa(JSON.stringify(result.tyre_dimensions.oe_rear)))
        } else {
            infoElement.textContent = this.formatTyresizeString(result.tyre_dimensions?.oe_front);
            clone.querySelector('button')?.setAttribute('data-result', btoa(JSON.stringify(result.tyre_dimensions.oe_front)))
        }
        this.axTyreMotionTyreChoice.appendChild(clone);
    }

    appendIndexButtons(index, axTyreMotionIndexChoice) {
        const templateButton = document.getElementById('axtyremotion-index');
        if(!Boolean(templateButton)) throw new HTMLElementNotFoundError('No template result found for speed index');
        const clone = templateButton.content.cloneNode(true);
        const infoElement = clone.querySelector('.info span');
        if(!Boolean(infoElement)) throw new HTMLElementNotFoundError('No before element found in result model template');
        infoElement.textContent = index;
        clone.querySelector('button')?.setAttribute('data-result', index)
        axTyreMotionIndexChoice.appendChild(clone);

    }

    formatTyresizeString(tyre_dimensions) {
        return tyre_dimensions?.width+'/'+tyre_dimensions?.height+' '+tyre_dimensions?.structure+' '+tyre_dimensions?.diameter+' '+tyre_dimensions?.load_index.replaceAll(';', '-')+' '+tyre_dimensions?.speed_index.replaceAll(';', '-');
    }
}